import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


export interface DialogButtion {
  text: string;
  disabled?: boolean;
  classes?: string[];
  data: any;
}

export const panelClasses = ['rounded-2xl', 'shadow-xl', 'overflow-hidden'];

export const defaultButtonTemplate = [
  {
    text: 'キャンセル',
    disabled: false,
    data: -1
  }
]

@Component({
  selector: 'app-common-dialog',
  templateUrl: './common-dialog.component.html'
})
export class CommonDialogComponent implements OnInit {

  // input for common
  @Input() headerLabel = "";
  @Input() hasHeader: boolean = true;
  @Input() hasFooter: boolean = true;
  @Input() buttons: DialogButtion[] = defaultButtonTemplate;

  // emitters
  @Output() close = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  closeDialog(data: any) {
    this.close.emit(data);
  }

}
